import { OnAnimationFrame } from "../../library-js/animation/OnAnimationFrame";
import { ElementAttribute } from "../../library-js/dom-tools/ElementAttribute";
import { DOMOrientation } from "../../library-js/dom/DOMOrientation";


export class KeepInsightElement extends HTMLElement
{
  _offset:number = 0;
}

export class KeepInsight
{
  static readonly attribute = new ElementAttribute( "-keep--insight" );
  static readonly maxHeightElement = new ElementAttribute( "-keep--insight--max--height-selector" );

  static _onAnimationFrame:OnAnimationFrame;
  static _hasListener = false;
  static _elements:HTMLElement[] = [];

  static applyOnDocument( onAnimationFrame:OnAnimationFrame )
  {
    if ( ! this._hasListener )
    {
      this._onAnimationFrame = onAnimationFrame;
      
      this._onAnimationFrame.addListener( () => { KeepInsight.update(); } );
      
      this._hasListener = true;

    }

    this._elements = [];
    
    KeepInsight.attribute.forEachInDoc( e => KeepInsight.applyOnElement( e ) );
  
    console.log( this._elements );
  }

  static update()
  {
    this._elements.forEach( e => KeepInsight.updateElement( e ) );
  }

  static updateElement( e:HTMLElement )
  {

    if ( DOMOrientation.isPortrait )
    {
      e.style.transform = "";
      return;
    }

    let k = e as KeepInsightElement;

    k._offset = k._offset || 0;

    let eRect = e.getBoundingClientRect();
    let rect = e.parentElement.getBoundingClientRect();

    let maxHeightAttribute = KeepInsight.attribute.from( e ); 
    let maxHeightElement = document.querySelector( maxHeightAttribute );

    let maxHeight = maxHeightElement == null ? 1000 : maxHeightElement.getBoundingClientRect().height;
    let offset = 50;

    // if ( DOMOrientation.isPortrait )
    // {
    //   offset = document.querySelector( "navi-header" ).getBoundingClientRect().height + 5;
    // }

    let y = Math.max( -offset, Math.min( -rect.top, maxHeight - ( eRect.height + offset ) ) );

    e.style.transform = `translateY(${offset + y}px)`; 

    // console.log( rect, y );

  }

  static applyOnElement( e:Element )
  {
    this._elements.push( e as HTMLElement );
  }
}